import { render } from "./Comuni.vue?vue&type=template&id=45863aa0"
import script from "./Comuni.vue?vue&type=script&lang=js"
export * from "./Comuni.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__